import { useState } from 'react'
import { Dialog, DialogContent } from '@mui/material'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'

import { DialogTitleClosable } from '@dhl/components'

import { Body2, Box, Button, Divider, Grid, H5, H6, Subtitle1 } from '@dhl-ui/components'

import { QuestionMarkIconStacked } from '@dhl-ui/icons'
import { EmailStatus } from '~/modules/checkemails/model'
import { InfoYellowIcon } from '~/common/components/icons'

type Props = {
  contactDetailsData: Array<EmailStatus>
  messageStatsData: Array<EmailStatus>
}

export const EmailStatusDetails = ({ contactDetailsData, messageStatsData }: Props) => {
  const { t } = useTranslation()
  const [isVisible, setIsVisible] = useState<boolean>(false)

  const handleClick = () => {
    setIsVisible(true)
  }

  const handleClose = () => {
    setIsVisible(false)
  }

  return (
    <Grid container size={{ xs: 12 }}>
      <Grid container direction="column" size={{ xs: 6 }} pl={2} columnGap={1}>
        <H6>{t('admin.checkEmailsPage.contactDetails')}</H6>
        <Box display="grid" sx={{ gridTemplateColumns: 'auto auto' }}>
          {contactDetailsData?.map((item, index) => (
            <>
              <Subtitle1>{item?.title}</Subtitle1>
              {index === 1 || index === 2 ? (
                <H6>{dayjs(`${item?.value}`).format('DD-MM-YYYY HH:mm:ss')}</H6>
              ) : (
                <Subtitle1>
                  {String(item?.value)}
                  {String(item?.value) === 'true' && (
                    <Button
                      sx={{ ml: 2 }}
                      color="primary"
                      onClick={handleClick}
                      variant="text"
                      size="large"
                      startIcon={<QuestionMarkIconStacked />}
                    >
                      {t('admin.checkEmailsPage.resolveBlocking')}
                    </Button>
                  )}
                </Subtitle1>
              )}
            </>
          ))}
        </Box>
      </Grid>

      <Grid container direction="column" size={{ xs: 6 }} columnGap={1}>
        <H6>{t('admin.checkEmailsPage.messageStatistics')}</H6>
        <Box display="grid" sx={{ gridTemplateColumns: 'auto auto' }}>
          {messageStatsData?.map((item) => (
            <>
              <Subtitle1>{item?.title}</Subtitle1>
              <Subtitle1>{item?.value}</Subtitle1>
            </>
          ))}
        </Box>
      </Grid>

      <Dialog data-testid="spam-complaining-dialog" open={isVisible} onClose={handleClose} fullWidth>
        <Box>
          <DialogTitleClosable onClose={handleClose}>
            <H5>{t('admin.checkEmailsPage.blockingSolutionDialog')}</H5>
          </DialogTitleClosable>
        </Box>
        <Divider />
        <DialogContent>
          <Body2>{t('admin.checkEmailsPage.blockingSolutionSteps')}</Body2>
          <Body2>
            <InfoYellowIcon />
            {t('admin.checkEmailsPage.blockingSolutionStep1')}
          </Body2>
          <Body2>
            <InfoYellowIcon />
            {t('admin.checkEmailsPage.blockingSolutionStep2')}
          </Body2>
          <Body2>
            <InfoYellowIcon />
            {t('admin.checkEmailsPage.blockingSolutionStep3')}
          </Body2>
          <Body2>{t('admin.checkEmailsPage.blockingSolutionStep4')}</Body2>
        </DialogContent>
        <Divider />
        <Box marginTop={1} display="flex" justifyContent="flex-end">
          <Box pr={1} pb={1}>
            <Button color="primary" variant="contained" size="large" onClick={handleClose}>
              {t('admin.checkEmailsPage.closeAction')}
            </Button>
          </Box>
        </Box>
      </Dialog>
    </Grid>
  )
}
